export const Folders = "PQSf9";
export default {Folders};